const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-banner">
        <h1>My Vinyls Collection</h1>
        <p>
          This is more than just a collection—it's years of crate-digging,
          late-night listening sessions, and the thrill of finding that perfect
          pressing. I've curated these vinyl records from across genres and eras
          because each one moved me in some way.
        </p>
        <a href="#metalcollection" className="btn hero-btn">
          Explore The Collection
        </a>
      </div>
    </section>
  )
};
export default Hero;
